/**
 * Hook de datos de los **KPIs del dashboard** (`GET /api/v1/core/dashboard`).
 *
 * Datos de servidor -> TanStack Query (`docs/frontend_conventions.md`, Datos): no
 * se usa `useState`+`useEffect`+`fetch` a mano. La query key incluye la sede
 * activa para **cachear por sede**: al cambiar de sede, los KPIs se recargan
 * (clave distinta) en vez de mostrar los de la sede anterior. La red la gobierna
 * `lib/api` (cookie httpOnly + `X-Sede-Id`).
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchDashboardStats } from "../api";
import type { DashboardStats } from "../types";

/** Query key de los KPIs del dashboard, segmentada por sede activa. */
export function dashboardStatsQueryKey(sedeId: number | null) {
  return ["dashboard", "stats", { sede: sedeId }] as const;
}

export function useDashboardStats() {
  const sedeId = getActiveSedeId();
  return useQuery<DashboardStats>({
    queryKey: dashboardStatsQueryKey(sedeId),
    queryFn: fetchDashboardStats,
    // Margen corto: el dashboard del SSR ya cachea por sede en el backend; aquí
    // evitamos refetch agresivo sin volver los KPIs rancios indefinidamente.
    staleTime: 30_000,
  });
}
